var map = {
	"./backgrounds/anno1800wallpaper.jpg": "8720",
	"./backgrounds/anno1800wallpaper@0,01x.jpg": "cc54",
	"./backgrounds/anno1800wallpaper@0,1x.jpg": "7e39",
	"./backgrounds/anno1800wallpaper@0,25x.jpg": "5efa",
	"./backgrounds/anno1800wallpaper@0,5x.jpg": "f19e",
	"./buildings/artisans/artisans.webp": "c4a1",
	"./buildings/artisans/balance.webp": "f540",
	"./buildings/artisans/beef.webp": "bf10",
	"./buildings/artisans/canned-food.webp": "16e8",
	"./buildings/artisans/coal.webp": "f3ee",
	"./buildings/artisans/cotton-fabric.webp": "5fa9",
	"./buildings/artisans/cotton.webp": "8b52",
	"./buildings/artisans/credits.webp": "7c76",
	"./buildings/artisans/entrancehedge.webp": "a7be",
	"./buildings/artisans/fountain-garden.webp": "d3cf",
	"./buildings/artisans/fur-coats.webp": "40fc",
	"./buildings/artisans/furs.webp": "6f3d",
	"./buildings/artisans/garden-benches.webp": "604f",
	"./buildings/artisans/garden.webp": "93d0",
	"./buildings/artisans/gazebo-garden.webp": "e2cc9",
	"./buildings/artisans/glass.webp": "0579",
	"./buildings/artisans/goulash.webp": "3b7c",
	"./buildings/artisans/hospital.webp": "d153",
	"./buildings/artisans/influence.webp": "ad15",
	"./buildings/artisans/memorial-statue-cult.webp": "6034",
	"./buildings/artisans/memorial-statue.webp": "7b49",
	"./buildings/artisans/museum.webp": "22da",
	"./buildings/artisans/newsstand-cult.webp": "4582",
	"./buildings/artisans/newsstand.webp": "d14d",
	"./buildings/artisans/path1.webp": "ea68",
	"./buildings/artisans/path2.webp": "f5f7",
	"./buildings/artisans/path3.webp": "096c",
	"./buildings/artisans/path4.webp": "8f02",
	"./buildings/artisans/path5.webp": "bd12",
	"./buildings/artisans/piazza-benches.webp": "a4e8",
	"./buildings/artisans/pier.webp": "ff79",
	"./buildings/artisans/public-mooring.webp": "08f2",
	"./buildings/artisans/quartz-sand.webp": "0230",
	"./buildings/artisans/red-peppers.webp": "dd00",
	"./buildings/artisans/repair-crane.webp": "8b67",
	"./buildings/artisans/rum.webp": "a3b4",
	"./buildings/artisans/sewing-machines.webp": "df72",
	"./buildings/artisans/sugar-cane.webp": "1906",
	"./buildings/artisans/town-hall.webp": "51e7",
	"./buildings/artisans/university.webp": "b64a",
	"./buildings/artisans/variety-theatre.webp": "932f",
	"./buildings/artisans/wideentrancehedge.webp": "aa98",
	"./buildings/artisans/windows.webp": "6a13",
	"./buildings/artisans/zoo.webp": "625a",
	"./buildings/elders/balance.webp": "e46a",
	"./buildings/elders/beeswax.webp": "40cb",
	"./buildings/elders/candles.webp": "d8bb",
	"./buildings/elders/cannon-tower.webp": "d6ea",
	"./buildings/elders/ceramics.webp": "6050",
	"./buildings/elders/clay.webp": "58a0",
	"./buildings/elders/credits.webp": "6467",
	"./buildings/elders/fuel.webp": "5564",
	"./buildings/elders/hospital.webp": "9fdf",
	"./buildings/elders/indigo.webp": "b849",
	"./buildings/elders/influence.webp": "6fc0",
	"./buildings/elders/lanterns.webp": "82f6",
	"./buildings/elders/monastery.webp": "824b",
	"./buildings/elders/mud-bricks.webp": "1bcc",
	"./buildings/elders/oil-harbour.webp": "7543",
	"./buildings/elders/oil-storage.webp": "23df",
	"./buildings/elders/paper.webp": "ff78",
	"./buildings/elders/paved-street.webp": "46e4",
	"./buildings/elders/pier.webp": "9229",
	"./buildings/elders/police-station.webp": "935a",
	"./buildings/elders/railway.webp": "202e",
	"./buildings/elders/resident-elder.webp": "1459",
	"./buildings/elders/scriptures.webp": "19c4",
	"./buildings/elders/seafood.webp": "16a9",
	"./buildings/elders/silo.webp": "9ef2",
	"./buildings/elders/spices.webp": "d491",
	"./buildings/elders/tapestries.webp": "cb64",
	"./buildings/elders/teff-flour.webp": "947d",
	"./buildings/elders/teff-grass.webp": "efda",
	"./buildings/elders/tobacco-pipes.webp": "0d5b",
	"./buildings/elders/town-hall.webp": "08dd",
	"./buildings/elders/tractorbarn.webp": "5ddb",
	"./buildings/elders/wat-stew.webp": "158f",
	"./buildings/engineers/advanced-weapons.webp": "dcf0",
	"./buildings/engineers/archway.webp": "e7ac",
	"./buildings/engineers/archway2.webp": "3862",
	"./buildings/engineers/attractiveness.webp": "b77c",
	"./buildings/engineers/balance.webp": "5f80",
	"./buildings/engineers/bank.webp": "90b9",
	"./buildings/engineers/big-betty.webp": "a0e5",
	"./buildings/engineers/brass.webp": "4210",
	"./buildings/engineers/bricks.webp": "c38c",
	"./buildings/engineers/caoutchouc.webp": "2b92",
	"./buildings/engineers/carbon-filament.webp": "fdf1",
	"./buildings/engineers/cement.webp": "6419",
	"./buildings/engineers/coffee-beans.webp": "ec3f",
	"./buildings/engineers/coffee.webp": "127d",
	"./buildings/engineers/commuter-pier.webp": "474a",
	"./buildings/engineers/copper.webp": "ba1f",
	"./buildings/engineers/credits.webp": "43b4",
	"./buildings/engineers/cypress.webp": "3ad2",
	"./buildings/engineers/dynamite.webp": "d420",
	"./buildings/engineers/engineers.webp": "94cb",
	"./buildings/engineers/equestrianstatuegarden.webp": "ef8e",
	"./buildings/engineers/fenceangle.webp": "e2cb",
	"./buildings/engineers/fencecrossing.webp": "e15b",
	"./buildings/engineers/fencecrossing2.webp": "2427",
	"./buildings/engineers/fenceend.webp": "8edf",
	"./buildings/engineers/fenceend2.webp": "9f1b",
	"./buildings/engineers/fencejunction.webp": "8058",
	"./buildings/engineers/fencejunction2.webp": "7e8e",
	"./buildings/engineers/fuel.webp": "ea6e",
	"./buildings/engineers/garden.webp": "db52",
	"./buildings/engineers/glasses.webp": "392c",
	"./buildings/engineers/gold-ore.webp": "45c6",
	"./buildings/engineers/gold.webp": "e901",
	"./buildings/engineers/high-wheeler.webp": "58af",
	"./buildings/engineers/influence.webp": "1486",
	"./buildings/engineers/light-bulb.webp": "6463",
	"./buildings/engineers/oil-harbour.webp": "8118",
	"./buildings/engineers/oil-power-plant.webp": "cac6",
	"./buildings/engineers/oil-storage.webp": "97da",
	"./buildings/engineers/oil.webp": "592e",
	"./buildings/engineers/oilwell.webp": "4e21",
	"./buildings/engineers/pocket-watch.webp": "b34e",
	"./buildings/engineers/railway.webp": "07c9",
	"./buildings/engineers/reinforced-concrete.webp": "45f8",
	"./buildings/engineers/saltpeter.webp": "618a",
	"./buildings/engineers/steam-motors.webp": "15c2",
	"./buildings/engineers/steam-shipyard.webp": "9627",
	"./buildings/engineers/steel-beams.webp": "8475",
	"./buildings/engineers/straightfence.webp": "27e2",
	"./buildings/engineers/tallcypress.webp": "4b2c",
	"./buildings/engineers/timber.webp": "d487",
	"./buildings/engineers/tractorbarn.webp": "cb17",
	"./buildings/engineers/windows.webp": "86d1",
	"./buildings/engineers/zinc.webp": "90c5",
	"./buildings/explorers/balance.webp": "f3c8",
	"./buildings/explorers/canteen.webp": "2768",
	"./buildings/explorers/caribou-hunting-cabin.webp": "b0f8",
	"./buildings/explorers/charcoal-kiln.webp": "f29b",
	"./buildings/explorers/credits.webp": "28be",
	"./buildings/explorers/explorers.webp": "ce2d",
	"./buildings/explorers/goose-farm.webp": "91c3",
	"./buildings/explorers/heater.webp": "f816",
	"./buildings/explorers/oil-lamp-factory.webp": "a0c3",
	"./buildings/explorers/pemmican-cookhouse.webp": "a325",
	"./buildings/explorers/ranger-station.webp": "8e69",
	"./buildings/explorers/residence.webp": "7cb9",
	"./buildings/explorers/road-arctic.webp": "fc5f",
	"./buildings/explorers/seal-hunting-docks.webp": "9b38",
	"./buildings/explorers/sleeping-bag-factory.webp": "e1d3",
	"./buildings/explorers/timber.webp": "67ed",
	"./buildings/explorers/warehouse.webp": "6c0c",
	"./buildings/explorers/whaling-station.webp": "c5a5",
	"./buildings/explorers/wood.webp": "db17",
	"./buildings/farmers/1602memorial.webp": "5600",
	"./buildings/farmers/appletree.webp": "db4d",
	"./buildings/farmers/balance.webp": "8e2f",
	"./buildings/farmers/bronzelion.webp": "6b7d",
	"./buildings/farmers/bush.webp": "a212",
	"./buildings/farmers/chesstables.webp": "b4ae",
	"./buildings/farmers/credits.webp": "cd2a",
	"./buildings/farmers/dirt-road.webp": "378e",
	"./buildings/farmers/farmers.webp": "8ba8",
	"./buildings/farmers/fire-station.webp": "4dec",
	"./buildings/farmers/fish.webp": "40ae",
	"./buildings/farmers/fountainsquare.webp": "f67c",
	"./buildings/farmers/fully-grown-tree.webp": "9df2",
	"./buildings/farmers/grass.webp": "5212",
	"./buildings/farmers/marketplace.webp": "c547",
	"./buildings/farmers/matureshrubbery.webp": "f468",
	"./buildings/farmers/potato.webp": "ce7d",
	"./buildings/farmers/pub.webp": "bef5",
	"./buildings/farmers/residence.webp": "6ef9",
	"./buildings/farmers/schnapps.webp": "2fc2",
	"./buildings/farmers/timber.webp": "458b",
	"./buildings/farmers/warehouse.webp": "785d",
	"./buildings/farmers/well.webp": "865f",
	"./buildings/farmers/wood.webp": "2079",
	"./buildings/farmers/wool.webp": "2d4f",
	"./buildings/farmers/work-clothes.webp": "4438",
	"./buildings/investors/attractiveness.webp": "a9aa",
	"./buildings/investors/balance.webp": "a125",
	"./buildings/investors/champagne.webp": "6c3d",
	"./buildings/investors/chassis.webp": "0880",
	"./buildings/investors/cigars.webp": "e7b2",
	"./buildings/investors/credits.webp": "a1e7",
	"./buildings/investors/electric-works-gas.webp": "b35f",
	"./buildings/investors/fountainplaza.webp": "e6de",
	"./buildings/investors/gazeboplaza.webp": "e65e",
	"./buildings/investors/gramophone.webp": "01eb",
	"./buildings/investors/grapes.webp": "a5bf",
	"./buildings/investors/investors.webp": "3430",
	"./buildings/investors/jewelry.webp": "41ad",
	"./buildings/investors/local-department.webp": "4cff",
	"./buildings/investors/members-club.webp": "7753",
	"./buildings/investors/palace.webp": "0dcd",
	"./buildings/investors/pearls.webp": "2be0",
	"./buildings/investors/steam-carriages.webp": "e81f",
	"./buildings/investors/tobacco.webp": "9b4e",
	"./buildings/investors/wood-veneers.webp": "01c4",
	"./buildings/investors/worlds-fair.webp": "4143",
	"./buildings/jornaleros/1602memorial.webp": "e011",
	"./buildings/jornaleros/alpaca-wool.webp": "0958",
	"./buildings/jornaleros/attractiveness.webp": "79d6",
	"./buildings/jornaleros/balance.webp": "82a0",
	"./buildings/jornaleros/bronzelion.webp": "b891",
	"./buildings/jornaleros/bushnw.webp": "a98c",
	"./buildings/jornaleros/caoutchouc.webp": "44dc",
	"./buildings/jornaleros/chesstables.webp": "a944",
	"./buildings/jornaleros/church.webp": "1901",
	"./buildings/jornaleros/cotton-fabric.webp": "2c5c",
	"./buildings/jornaleros/cotton.webp": "611c",
	"./buildings/jornaleros/credits.webp": "035e",
	"./buildings/jornaleros/depot.webp": "6bbb",
	"./buildings/jornaleros/dirt-road.webp": "a5cf",
	"./buildings/jornaleros/entrancehedge.webp": "8db0",
	"./buildings/jornaleros/ferns.webp": "0e7f",
	"./buildings/jornaleros/fire-station.webp": "9721",
	"./buildings/jornaleros/fish-oil.webp": "2529",
	"./buildings/jornaleros/fountainsquare.webp": "e205",
	"./buildings/jornaleros/fried-plantains.webp": "defb",
	"./buildings/jornaleros/grass.webp": "700e",
	"./buildings/jornaleros/harbourmasters-office.webp": "ad44",
	"./buildings/jornaleros/hedgeanglenw.webp": "842c",
	"./buildings/jornaleros/hedgecrossingnw.webp": "7934",
	"./buildings/jornaleros/hedgeendnw.webp": "b38c",
	"./buildings/jornaleros/hedgewallnw.webp": "9607",
	"./buildings/jornaleros/influence.webp": "0710",
	"./buildings/jornaleros/jornaleros.webp": "7943",
	"./buildings/jornaleros/marketplace.webp": "e2ef",
	"./buildings/jornaleros/mounted-guns.webp": "06fa",
	"./buildings/jornaleros/palmtree.webp": "ac91",
	"./buildings/jornaleros/path1.webp": "a99c",
	"./buildings/jornaleros/path2.webp": "43ef",
	"./buildings/jornaleros/path3.webp": "3dbe",
	"./buildings/jornaleros/path4.webp": "1fed",
	"./buildings/jornaleros/path5.webp": "effa",
	"./buildings/jornaleros/pearls.webp": "befe",
	"./buildings/jornaleros/philodendron.webp": "a6ce",
	"./buildings/jornaleros/plantains.webp": "ab02",
	"./buildings/jornaleros/police-station.webp": "fa5d",
	"./buildings/jornaleros/poncho.webp": "88d2",
	"./buildings/jornaleros/quay.webp": "6f23",
	"./buildings/jornaleros/repair-crane.webp": "b429",
	"./buildings/jornaleros/residence.webp": "6e1c",
	"./buildings/jornaleros/rum.webp": "c55d",
	"./buildings/jornaleros/sailing-shipyard.webp": "4a77",
	"./buildings/jornaleros/sails.webp": "6e4b",
	"./buildings/jornaleros/shrubnw.webp": "cc4e",
	"./buildings/jornaleros/smallpalmtree.webp": "8145",
	"./buildings/jornaleros/smalltreenw.webp": "d515",
	"./buildings/jornaleros/straighthedgenw.webp": "6fe7",
	"./buildings/jornaleros/sugar-cane.webp": "ccc1",
	"./buildings/jornaleros/timber.webp": "b2b6",
	"./buildings/jornaleros/trade-union.webp": "73d9",
	"./buildings/jornaleros/warehouse.webp": "14bf",
	"./buildings/jornaleros/well.webp": "0fda",
	"./buildings/jornaleros/wood.webp": "29a6",
	"./buildings/obreros/archway.webp": "1164",
	"./buildings/obreros/archway2.webp": "89b8",
	"./buildings/obreros/attractiveness.webp": "973c",
	"./buildings/obreros/balance.webp": "3839",
	"./buildings/obreros/beef.webp": "3dd3",
	"./buildings/obreros/bowler-hats.webp": "e983",
	"./buildings/obreros/boxing-arena.webp": "af74",
	"./buildings/obreros/bricks.webp": "da65",
	"./buildings/obreros/cannon-tower.webp": "fe06",
	"./buildings/obreros/chocolate.webp": "bb3c",
	"./buildings/obreros/cigars.webp": "9753",
	"./buildings/obreros/clay.webp": "fb68",
	"./buildings/obreros/cocoa.webp": "1fd0",
	"./buildings/obreros/coffee-beans.webp": "4a41",
	"./buildings/obreros/coffee.webp": "6394",
	"./buildings/obreros/corn.webp": "3905",
	"./buildings/obreros/credits.webp": "220c",
	"./buildings/obreros/equestrianstatuegarden.webp": "d122",
	"./buildings/obreros/felt.webp": "56c1",
	"./buildings/obreros/fenceangle.webp": "883c",
	"./buildings/obreros/fencecrossing2.webp": "71f3",
	"./buildings/obreros/fencecrossingnw.webp": "13a8",
	"./buildings/obreros/fenceend.webp": "c698",
	"./buildings/obreros/fenceend2.webp": "1e82",
	"./buildings/obreros/fencejunction2.webp": "4b9b",
	"./buildings/obreros/fencewallnw.webp": "f3e4",
	"./buildings/obreros/floweringshrub.webp": "221d",
	"./buildings/obreros/fountain-garden.webp": "d1c2",
	"./buildings/obreros/fountainplazanw.webp": "3188",
	"./buildings/obreros/fuel.webp": "0885",
	"./buildings/obreros/garden-benches.webp": "62cd",
	"./buildings/obreros/garden.webp": "c639",
	"./buildings/obreros/gardennw.webp": "3bd6",
	"./buildings/obreros/gazebo-garden.webp": "9fca",
	"./buildings/obreros/gazeboplazanw.webp": "10a5",
	"./buildings/obreros/gold-ore.webp": "ca81",
	"./buildings/obreros/hospital.webp": "9f71",
	"./buildings/obreros/influence.webp": "4819",
	"./buildings/obreros/memorial-statue-cult.webp": "7684",
	"./buildings/obreros/memorial-statue.webp": "2f68",
	"./buildings/obreros/museum.webp": "0310",
	"./buildings/obreros/newsstand-cult.webp": "0279",
	"./buildings/obreros/newsstand.webp": "92f2",
	"./buildings/obreros/obreros.webp": "57a1",
	"./buildings/obreros/oil-harbour.webp": "ecc0",
	"./buildings/obreros/oil-storage.webp": "dbf3",
	"./buildings/obreros/oil.webp": "201f",
	"./buildings/obreros/oilwell.webp": "e5e8",
	"./buildings/obreros/paved-street.webp": "f19a",
	"./buildings/obreros/piazza-benches.webp": "75d9",
	"./buildings/obreros/pier.webp": "ae21",
	"./buildings/obreros/public-mooring.webp": "a415",
	"./buildings/obreros/railway.webp": "6cba",
	"./buildings/obreros/reinforced-concrete.webp": "d1ce",
	"./buildings/obreros/silo.webp": "07ad",
	"./buildings/obreros/straightfence.webp": "be46",
	"./buildings/obreros/straightfencenw.webp": "3e94",
	"./buildings/obreros/sugar.webp": "3ade",
	"./buildings/obreros/tobacco.webp": "7f69",
	"./buildings/obreros/tortilla.webp": "20bb",
	"./buildings/obreros/town-hall.webp": "f892",
	"./buildings/obreros/tractorbarn.webp": "69e6",
	"./buildings/obreros/tropicalforest.webp": "39cd",
	"./buildings/obreros/wateringhole.webp": "2915",
	"./buildings/obreros/wideentrancehedge.webp": "4590",
	"./buildings/obreros/wood-veneers.webp": "8d94",
	"./buildings/obreros/zoo.webp": "8517",
	"./buildings/scholars/balance.webp": "78f0",
	"./buildings/scholars/coffee.webp": "c398",
	"./buildings/scholars/cotton-fabric.webp": "f282",
	"./buildings/scholars/credits.webp": "c262",
	"./buildings/scholars/leather-shoes.webp": "3e90",
	"./buildings/scholars/radio-station.webp": "ac19",
	"./buildings/scholars/research-center.webp": "08fc",
	"./buildings/scholars/residence-scholars.webp": "41e2",
	"./buildings/scholars/resident-scholars.webp": "28b3",
	"./buildings/scholars/rum.webp": "a7f2",
	"./buildings/scholars/suits.webp": "c6d2",
	"./buildings/scholars/telephones.webp": "06ed",
	"./buildings/shepherds/balance.webp": "ba39",
	"./buildings/shepherds/canal.webp": "b629",
	"./buildings/shepherds/credits.webp": "cf9a",
	"./buildings/shepherds/depot.webp": "cf77",
	"./buildings/shepherds/desert-road.webp": "4668",
	"./buildings/shepherds/dried-meat.webp": "9b13",
	"./buildings/shepherds/fire-station.webp": "1e46",
	"./buildings/shepherds/goat-milk.webp": "b12e",
	"./buildings/shepherds/harbourmasters-office.webp": "d0eb",
	"./buildings/shepherds/hibiscus-farm.webp": "cb06",
	"./buildings/shepherds/hibiscus-tea.webp": "4b12",
	"./buildings/shepherds/influence.webp": "5794",
	"./buildings/shepherds/linen-fabric.webp": "de48",
	"./buildings/shepherds/linen-farm.webp": "5f5a",
	"./buildings/shepherds/marketplace.webp": "14c6",
	"./buildings/shepherds/mounted-guns.webp": "78cc",
	"./buildings/shepherds/music-plaza.webp": "0d65",
	"./buildings/shepherds/quay.webp": "435b",
	"./buildings/shepherds/repair-crane.webp": "7645",
	"./buildings/shepherds/residence.webp": "e9cf",
	"./buildings/shepherds/resident-sheperd.webp": "498a2",
	"./buildings/shepherds/salt.webp": "8dce",
	"./buildings/shepherds/trade-union.webp": "a86e",
	"./buildings/shepherds/traditional-clothing.webp": "1654",
	"./buildings/shepherds/wansa-wood.webp": "d162",
	"./buildings/shepherds/warehouse.webp": "b7fd",
	"./buildings/shepherds/water-pump.webp": "592c",
	"./buildings/shepherds/watusi.webp": "62a1",
	"./buildings/technicians/airship-hangar.webp": "fa17",
	"./buildings/technicians/arctic-lodge.webp": "0962",
	"./buildings/technicians/balance.webp": "f9c5",
	"./buildings/technicians/bear-hunting-cabin.webp": "1def",
	"./buildings/technicians/cannon-tower.webp": "0d16",
	"./buildings/technicians/credits.webp": "5281",
	"./buildings/technicians/depot.webp": "03d9",
	"./buildings/technicians/furs.webp": "7008",
	"./buildings/technicians/gas-mine.webp": "2840",
	"./buildings/technicians/gold-ore.webp": "f9ab",
	"./buildings/technicians/husky-farm.webp": "1cf3",
	"./buildings/technicians/husky-sled-factory.webp": "6221",
	"./buildings/technicians/influence.webp": "1719",
	"./buildings/technicians/parka-factory.webp": "5f6e",
	"./buildings/technicians/pier.webp": "6db5",
	"./buildings/technicians/post-office.webp": "3555",
	"./buildings/technicians/sled-frame-factory.webp": "9d11",
	"./buildings/technicians/technicians.webp": "dd4c",
	"./buildings/workers/attractiveness.webp": "6279",
	"./buildings/workers/balance.webp": "98e0",
	"./buildings/workers/beer.webp": "b018",
	"./buildings/workers/bread.webp": "2cb6",
	"./buildings/workers/bricks.webp": "19d1",
	"./buildings/workers/cannon-tower.webp": "5ed2",
	"./buildings/workers/charcoal-kiln.webp": "682b",
	"./buildings/workers/church.webp": "72c4",
	"./buildings/workers/clay.webp": "359b",
	"./buildings/workers/credits.webp": "d74a",
	"./buildings/workers/depot.webp": "27a9",
	"./buildings/workers/elmtree.webp": "8859",
	"./buildings/workers/flour.webp": "65b3",
	"./buildings/workers/flowerbed.webp": "0f0a",
	"./buildings/workers/grain.webp": "127f",
	"./buildings/workers/harbourmasters-office.webp": "ac1fd",
	"./buildings/workers/hops.webp": "b373",
	"./buildings/workers/influence.webp": "7716",
	"./buildings/workers/iron.webp": "26d6",
	"./buildings/workers/malt.webp": "55c2",
	"./buildings/workers/mounted-guns.webp": "0a82",
	"./buildings/workers/paved-street.webp": "7758",
	"./buildings/workers/pigs.webp": "a075",
	"./buildings/workers/police-station.webp": "1004",
	"./buildings/workers/poplar.webp": "f00e",
	"./buildings/workers/poplar2.webp": "0357",
	"./buildings/workers/quay.webp": "5705",
	"./buildings/workers/sailing-shipyard.webp": "bfc2",
	"./buildings/workers/sails.webp": "dc49",
	"./buildings/workers/sausages.webp": "d849",
	"./buildings/workers/school.webp": "573a",
	"./buildings/workers/silo.webp": "cc75",
	"./buildings/workers/small-tree.webp": "2e48",
	"./buildings/workers/soap.webp": "24b7",
	"./buildings/workers/steel-beams.webp": "ffbb",
	"./buildings/workers/steel.webp": "ca29",
	"./buildings/workers/tallow.webp": "214f",
	"./buildings/workers/temperategrove.webp": "404a",
	"./buildings/workers/trade-union.webp": "60fb",
	"./buildings/workers/tremblingaspen.webp": "822c",
	"./buildings/workers/wateringhole.webp": "9216",
	"./buildings/workers/weapons.webp": "7b7e",
	"./buildings/workers/workers.webp": "6d96",
	"./dlcs/amusement-pack.jpg": "f4b7",
	"./dlcs/anno-1800.jpg": "8529",
	"./dlcs/botanica.webp": "3307",
	"./dlcs/bright-harvest.webp": "c38a",
	"./dlcs/holiday-pack.webp": "5a03",
	"./dlcs/land-of-lions.webp": "b465",
	"./dlcs/season-pass-2.webp": "d9cb",
	"./dlcs/seat-of-power.webp": "8b6e",
	"./dlcs/sunken-treasures.webp": "d13e",
	"./dlcs/the-anarchist--edited.webp": "153a",
	"./dlcs/the-anarchist.webp": "d274",
	"./dlcs/the-passage.webp": "9265",
	"./icons/attractiveness-icon.webp": "6f52",
	"./icons/balance.webp": "2a7e",
	"./icons/icon-credits.webp": "cb8c",
	"./icons/workforce-artisans.webp": "2c29",
	"./icons/workforce-elders.webp": "1bff",
	"./icons/workforce-engineers.webp": "5b36",
	"./icons/workforce-explorers.webp": "bc66",
	"./icons/workforce-farmers.webp": "7f19",
	"./icons/workforce-jornaleros.webp": "b586",
	"./icons/workforce-obreros.webp": "a591",
	"./icons/workforce-shepherds.webp": "b977",
	"./icons/workforce-technicians.webp": "1b27",
	"./icons/workforce-workers.webp": "a438",
	"./logos/epic_games.svg": "4874",
	"./logos/uplay.png": "2064",
	"./population/artisans.webp": "d4ac",
	"./population/elders.webp": "671f",
	"./population/engineers.webp": "3a42",
	"./population/explorers.webp": "103d",
	"./population/farmers.webp": "b96a",
	"./population/investors.webp": "2535",
	"./population/jornaleros.webp": "ac18",
	"./population/obreros.webp": "4198",
	"./population/population.webp": "8a22",
	"./population/scholars.webp": "d47d",
	"./population/shepherd.webp": "ff49",
	"./population/technicians.webp": "1e47",
	"./population/workers.webp": "36b4",
	"./regions/cape-trelawney.webp": "5720",
	"./regions/enbesa.webp": "0cb1",
	"./regions/the-arctic.webp": "4446",
	"./regions/the-new-world.webp": "7c21",
	"./regions/the-old-world.webp": "6ca8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";